import React from 'react';
import './Footer.css';

import logoFooter from './assets/logoFooter.png';

import { FaInstagram, FaWhatsapp, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className="footer__container">
      <div className="footer__first">
        <p className="text__footer">
          Siempre listos para trabajar en equipo, brindar las mejores soluciones
          a los usuarios y digitalizar tus sueños.
        </p>
      </div>
      <div className="footer__second">
        <div className="methods__contact">
          <div className="method">
            <h4 className="method__title">Teléfono</h4>
            <a href="tel:+54 9 11 3700-1199" className="method__text">
              +54 9 11 3700-1199
            </a>
          </div>
          <div className="method">
            <h4 className="method__title">Dirección</h4>
            <a href="/" className="method__text address">
              Gregorio de Laferrere/Buenos Aires, ARG
            </a>
          </div>
          <div className="method">
            <h4 className="method__title">Correo Electrónico</h4>
            <a href="mailto:eliumnova@hotmail.com" className="method__text">
              eliumnova@hotmail.com
            </a>
          </div>
        </div>
      </div>
      <div className="footer__thirt">
        <div className="img__container">
          <img src={logoFooter} alt="" className="img__footer" />
        </div>
      </div>
      <div className="footer__fourt">
        <div className="apps__container">
          <a
            href="/"
            className="app instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="icon" />
          </a>
          <a
            href="https://wa.me/message/VRAREXKMRRRME1"
            className="app whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="icon" />
          </a>
          <a
            href="https://www.linkedin.com/company/eliumnova/"
            className="app linkedin"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="icon" />
          </a>
        </div>
        <p className="text__footer-ult">
          © 2024 EliumNova. Todos los derechos reservados. 'EliumNova' se
          refiere a la marca bajo la cual se prestan servicios IT, tales como
          Development, Solutions, Technical Support, según lo requiera el
          contexto. Los servicios son prestados por EliumNova.
        </p>
      </div>
    </div>
  );
};

export default Footer;
